import { TSpecWithRoleOption } from '../frontend/scripts/wow/components/controls/types';
import { TSpecSummary } from '../types/utilityTypes';
import { ExtendedSpecRole, SpecRole } from '../types/wowTypes';

export const isSpecSummary = (option: TSpecWithRoleOption): option is TSpecSummary => {
  if (typeof option === 'string') {
    return false;
  }

  return true;
};

export const isExtendedSpecRole = (value: unknown): value is ExtendedSpecRole => {
  return Object.values(ExtendedSpecRole).includes(value as ExtendedSpecRole);
};

export const isSpecRole = (value: unknown): value is SpecRole => {
  return Object.values(SpecRole).includes(value as SpecRole);
};

export const getExtendedSpecRoleFromSpec = (spec: TSpecSummary): ExtendedSpecRole => {
  if (spec.role === SpecRole.DPS) {
    return spec.is_melee ? ExtendedSpecRole.MeleeDps : ExtendedSpecRole.RangedDps;
  }

  return spec.role as ExtendedSpecRole;
};

export const extendedSpecRoleToSpecRole = (role: ExtendedSpecRole | SpecRole): SpecRole => {
  if (role === ExtendedSpecRole.MeleeDps || role === ExtendedSpecRole.RangedDps) {
    return SpecRole.DPS;
  }

  return role as unknown as SpecRole;
};

export function getRoleIconForSpec(spec: TSpecSummary): string {
  switch (spec.role) {
    case 'dps':
      return `dps-${spec.is_melee ? 'melee' : 'ranged'}`;
    case 'healer':
      return 'healer';
    case 'tank':
      return 'tank';
    default:
      return 'red-x';
  }
}

export const isSpecMatchRole = (spec: TSpecSummary, role: ExtendedSpecRole | SpecRole): boolean => {
  const specExtendedRole = getExtendedSpecRoleFromSpec(spec);

  if (isExtendedSpecRole(role)) {
    return specExtendedRole === role;
  }

  return extendedSpecRoleToSpecRole(specExtendedRole) === role;
};

export const EXTENDED_ROLES_TO_PRIMARY_ROLE_MAP: Record<ExtendedSpecRole, SpecRole> = {
  [ExtendedSpecRole.MeleeDps]: SpecRole.DPS,
  [ExtendedSpecRole.RangedDps]: SpecRole.DPS,
  [ExtendedSpecRole.Healer]: SpecRole.Healer,
  [ExtendedSpecRole.Tank]: SpecRole.Tank
};
